// extracted by mini-css-extract-plugin
export default {"keyvisual":"keyvisual___19iwu","image":"image___24AEm","content":"content___-lz4o","subheadline":"subheadline___rdxt3","headline":"headline___3pFtO"};